import React, { useCallback, useEffect, useRef, useState } from "react";

import { HiOutlineSwitchVertical } from "react-icons/hi";

import {
  BottomBar,
  Complement,
  Container,
  Divisor,
  Header,
  Title,
  TitleWrapper,
  UnitItem,
  UnitItemComplement,
  UnitItemTitle,
  UnitListTitle,
  UnitsList,
  UnitsWrapper,
} from "./styles";
import { useGaEvents } from "pages/BoletoRapido/hooks/useGaEvents";
import { useQuickBillContext } from "pages/BoletoRapido/hooks/useQuickBill";

const ChangeOfUnit = (): JSX.Element => {
  const ChangeOfToggleButton = useRef(null);
  const {
    units,
    selectedUnit,
    setSelectedUnit,
    document: documentContext,
  } = useQuickBillContext();

  const { handleClickChangeUnit } = useGaEvents();

  const [openDrawer, setOpenDrawer] = useState(false);

  const handleClickOutside = useCallback(
    (event) => {
      if (ChangeOfToggleButton) {
        const { path } = event;
        if (!!path && !path.includes(ChangeOfToggleButton.current)) {
          setOpenDrawer(false);
        }
      }
    },
    [ChangeOfToggleButton]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
  }, []);

  const toggleOpenDrawer = (): void => {
    setOpenDrawer((prevState) => !prevState);
  };

  return (
    <Container onClick={toggleOpenDrawer} ref={ChangeOfToggleButton}>
      <Header>
        {selectedUnit?.condominiumName && (
          <TitleWrapper>
            <Title>{selectedUnit?.condominiumName}</Title>
            <Complement>{selectedUnit?.name}</Complement>
          </TitleWrapper>
        )}
        <HiOutlineSwitchVertical size={16} color="rgb(0, 0, 255)" />
      </Header>
      <UnitsList show={openDrawer}>
        <Divisor />
        <UnitListTitle>Unidades:</UnitListTitle>
        <UnitsWrapper>
          {units?.map((unit) => (
            <UnitItem
              selected={unit.instanceId === selectedUnit.instanceId}
              onClick={() => {
                handleClickChangeUnit(documentContext, unit);
                setSelectedUnit(unit);
              }}
            >
              <UnitItemTitle>{unit.condominiumName}</UnitItemTitle>
              <UnitItemComplement>{unit.name}</UnitItemComplement>
            </UnitItem>
          ))}
        </UnitsWrapper>
      </UnitsList>
      <BottomBar>Filtrar unidade</BottomBar>
    </Container>
  );
};

export default ChangeOfUnit;
